/*
 * ==============================================================================
 *
 * Copyright (c) 2023. Koninklijke Philips Electronics N.V.
 *
 * All rights are reserved. Reproduction in whole or in part is prohibited without the prior written consent of the copyright holder.
 *
 * ==============================================================================
 */

import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import { Link, useHistory } from "react-router-dom";
import { login } from "../auth/service";
import { setAuthData } from "./store";
import Button from "./com/button";

const LoginPg = ({ onError }) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const [submitText, setSubmitText] = useState("Login");
  const { handleSubmit, register, errors } = useForm();
  const [showPopup, setShowPopup] = useState(false);

  const redirect = () => {
    const url = new URLSearchParams(history.location.search);
    const rb = url.get("rb");
    if (rb) {
      window.location.replace(rb);
    } else window.location.replace("/reports3");
  };

  const setButtonText = (text, cb = () => {}) => {
    setSubmitText(text);
    setTimeout(() => {
      setSubmitText("Login");
      cb();
    }, 1500);
  };

  const onLogin = async ({ email, password }) => {
    try {
      if (!navigator.onLine) setButtonText("Please check your Internet connection");
      else {
        setIsLoading(true);
        dispatch(setAuthData({ email, password }));
        const res = await login(email, password);
        if (res.token) {
          if (!localStorage.getItem("genToken")) {
            sessionStorage.setItem("showModalRetireApp", true);
          }
          localStorage.setItem("genToken", JSON.stringify({ user: res.user.username, token: res.token }));
          localStorage.setItem("showUserAgreements", true);
          redirect();
        } else if (res.errors && res.errors[0].msg === "The authCode is required.") {
          setIsLoading(false);
          setButtonText("2 Factor Authentication Required...", () => {
            history.push("/auth/verify");
          });
        } else {
          if (res.errors[0].msg == 'User account is locked') {
            setShowPopup(true);
          }
          setIsLoading(false);
          setButtonText(res.errors[0].msg);
        }
      }
    } catch (error) {
      setIsLoading(false);
      if (onError) onError(error);
      else {
        setSubmitText(error.message);
        setTimeout(() => {
          setSubmitText("Login");
        }, 2000);
      }
    }
  };

  const popupModalValidation = () => {
    return showPopup ? (
      <div className="modal override-row popup show" id="modalAgreements">
        <div className="modalContent">
          <div className="grpHdr">
            <h2>Exceeded password attempts. Account locked.</h2>
          </div>
          <p>Click 'Forgot your password?' below to reset securely. For further assistance, contact customer success at customersuccess@philips.com/844-525-5115 </p>
          <div className="row rowStretch noMargin">
            <button className="btn btn-sm btn-teal" onClick={() => setShowPopup(false)}>
              OK
            </button>
          </div>
        </div>
      </div>
    ) : null;
  };

  return (
    <div className="page">
      <div className="geneva-logo" style={{ transform: "scale(0.6)" }} />
      <div className="root">
        <form onSubmit={handleSubmit(onLogin)} className="tl-form">
          <div className="area">
            <h1 id="login-header-id">Login</h1>
            <input
              id="email-input-id"
              className="tl-inp"
              type="text"
              placeholder="Enter email or username..."
              name="email"
              ref={register({
                required: "Email or username is required",
                pattern: {
                  value: /^([A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}|[A-Z0-9]{5,})$/i,
                  message: "Invalid email address or username",
                },
              })}
            />
            <span className="err">{errors.email && errors.email.message}</span>
            <input
              id="password-input-id"
              className="tl-inp"
              type="password"
              placeholder="Enter password..."
              name="password"
              ref={register({
                required: "Password is required",
              })}
            />
            <span className="err">{errors.password && errors.password.message}</span>
          </div>
          <Button id="login-btn" className="btn tl-btn" type="submit" isLoading={isLoading}>
            {submitText}
          </Button>
        </form>
      </div>
      <div className="fp">
        <a
          id="privace-policy-id"
          href="https://www.philips.com/a-w/privacy-notice.html"
          target="_blank"
          rel="noreferrer"
          style={{ paddingRight: "120px" }}
        >
          Privacy Policy
        </a>
        <a
          href="https://shared-genevahealthcare-com.s3.us-west-1.amazonaws.com/portal/assets/Terms+of+Use+%E2%80%93+Geneva+Health+Solutions.pdf"
          target="_blank"
          rel="noreferrer"
          id="terms-of-use"
          style={{ paddingRight: "80px" }}
        >
          Terms of Use
        </a>
        <Link to="forgot">Forgot your password?</Link>
      </div>
      {popupModalValidation()}
    </div>
  );
};

export default LoginPg;
